import moment from 'moment-timezone';

const formatMoneyCommaAndCentsPrecise = (amount = 0, places = 2) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: places,
    maximumFractionDigits: places,
  }).format(amount);
};

export default class DisplayHelper {
  static formatMoneyK(amount) {
    if (amount > 10000) {
      const thousands = Math.trunc(amount / 1000);
      return `$${thousands}K`;
    }
    return `$${Math.round(amount)}`;
  }

  static formatMoneyComma(amount) {
    if (amount === undefined || amount === null) {
      return '';
    }
    return formatMoneyCommaAndCentsPrecise(amount, 0);
  }

  static formatMoneyCommaAndCents(amount = 0, places = 2) {
    const formattedNumber = amount.toFixed(places).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    return `$${formattedNumber}`;
  }

  static formatNumberCommaAndPlaces = (amount = 0, places = 2) =>
    amount.toFixed(places).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');

  static formatNumberComma = (amount) =>
    Math.round(amount)
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

  static formatNumberComma100(amount) {
    amount = Math.round(amount * 100) / 100;
    return amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  static formatNumberRemoveComma(amount) {
    if (typeof amount === 'number' || typeof amount === 'string') {
      return amount.toString().replace(/,/g, '');
    }
    return amount;
  }

  static formatAPR(apr) {
    if (apr === null) {
      return `Variable`; // handle risk based pricing
    } else if (apr % 1 === 0) {
      return `${apr}%`;
    } else if ((apr * 10) % 1 === 0) {
      // add a zero for better visual if only single decimal, since most APRs are two decimals
      return `${apr.toFixed(2)}%`;
    }
    return `${apr}%`;
  }

  static formatNumberCommaInProgress(amount) {
    if (typeof amount === 'number' || typeof amount === 'string') {
      amount = amount.toString().replace(/,/g, '');
      let parts = amount.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return amount;
  }

  // improved rounding precision than .toFixed() offers (i.e. 0.105 rounds to 0.11 instead of 0.10)
  static precisionRound = (value, decimals) => Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);

  static capitalizeFirstLetter = (string) => {
    if (!string || typeof string !== 'string' || string.length < 2) {
      return string;
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  static formatDateV2 = (date, includeSuffix = false) =>
    moment
      .utc(date, 'YYYY-MM-DD hh:mm:ss')
      .local()
      .format(`MM/DD/YY ${includeSuffix ? 'hh' : 'HH'}:mm ${includeSuffix ? 'A' : ''}`);

  static formatDateV2Seconds = (date) => moment.utc(date, 'YYYY-MM-DD hh:mm:ss').local().format('MM/DD/YY HH:mm:ss');

  static formatDateTime = (date) => moment.utc(date, 'YYYY-MM-DD hh:mm:ss').local().format('HH:mm');

  static formatDateNoTime = (date) => moment.utc(date, 'YYYY-MM-DD hh:mm:ss').local().format('MM/DD/YYYY');

  static formatLocalDateNoTime = (date) => moment(date, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY');

  static formatTimelessDateNoTime = (date) => moment.utc(date, 'YYYY-MM-DD').format('MM/DD/YYYY');

  static formatMoneyCommaAndCentsPrecise = formatMoneyCommaAndCentsPrecise;

  static formatPhoneNumber(strNumber) {
    let nStr = (strNumber || '').replace('+1', '').replace(/\D/g, '');

    if (nStr.length === 10) {
      return `(${nStr.substr(0, 3)}) ${nStr.substr(3, 3)}-${nStr.substr(6, 4)}`;
    }
    return nStr;
  }

  static unformatPhoneNumber(phone) {
    return (phone || '').replace(/[^\d]/g, '');
  }

  static formatContractorPhone(phone) {
    let format = (phone) => `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6, 10)}`;
    if (!phone) {
      return 'Unavailable';
    }

    let formatLess = DisplayHelper.unformatPhoneNumber(phone);
    if (formatLess.length === 11) {
      return format(formatLess.slice(1));
    }
    if (formatLess.length < 10 || formatLess.length > 11) {
      return phone; // this number is messed up we're going to return it, but its not great
    }
    return format(formatLess);
  }

  static formatContractorPhoneWithExtensionText(phone, ext) {
    const formattedPhone = DisplayHelper.formatContractorPhone(phone);
    if (!ext && ext !== ' ') {
      return formattedPhone;
    }
    return `${formattedPhone}, ext. ${ext}`;
  }

  static formatContractorPhoneWithExtensionTag(phone, ext) {
    const formattedPhone = DisplayHelper.unformatPhoneNumber(phone);
    if (!ext && ext !== ' ') {
      return `tel:${formattedPhone}`;
    }
    return `tel:${formattedPhone},${ext}`;
  }

  static formatSSN(ssn) {
    return `${ssn.slice(0, 3)}-${ssn.slice(3, 5)}-${ssn.slice(5, 10)}`;
  }

  static formatProductName(productName) {
    return productName?.replace('Concert ', '');
  }
}
